// https://stackoverflow.com/questions/149055/how-to-format-numbers-as-currency-string
const formatMoney = (amount: number | string | null) => {
  const value = isNaN(Number(amount)) ? 0 : Number(amount);
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  return formatter.format(value);
};

export default formatMoney;
